module.exports = __webpack_public_path__ + "img/programming-34.bef74337.svg";